import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { TextComponent } from "./TextComponent";

interface NavItemProps {
	title: string;
	icon?: JSX.Element;
	href?: string;
	variant?: "header" | "primary";
	hiddenText?: boolean;
	className?: string;
	onClick?: () => void;
	marked?: boolean;
}

export const NavItem = ({ title, icon, href = "#", variant = "primary", hiddenText = false, onClick, className, marked }: NavItemProps) => {
	const baseClass = `flex + ${className}`;
	const location = useLocation();
	const isActive = variant === "header" ? location.pathname === href : href === "/" ? location.pathname === href : location.pathname.startsWith(href);

	let combinedClass;

	if (variant === "header") {
		combinedClass = `gap-1 transition-colors duration-300 max-md:px-4 max-md:py-2 pb-1 pt-1 md:border-b-2 md:hover:border-b-white hover:text-white ${baseClass} ${
			isActive || marked ? "md:border-b-white text-cyan-600 md:text-white font-bold max-md:bg-cyan-200" : "text-white md:border-b-transparent"
		}`;
	} else {
		combinedClass = `gap-2 p-3 items-center rounded-md hover:bg-cyan-600 ${baseClass} ${isActive || marked ? "bg-cyan-600 text-white" : "transition-colors duration-300 hover:text-white "}`;
	}

	return (
		<Link
			to={href}
			className={`select-none ${combinedClass}`}
			onClick={onClick}
		>
			{icon}
			<TextComponent
				variant="h5"
				className={`${hiddenText && "max-md:hidden"}`}
			>
				{title}
			</TextComponent>
		</Link>
	);
};
